module.exports = __webpack_public_path__ + "static/media/jerry.37aa7b7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadBackgroundImg/jerry.jpg
// module id = 714
// module chunks = 0